import { fetchProjectActions } from '../actions/fetchProject';
import { fetchProject } from '../../../api/projectsApi';
import createFetchSaga from './createFetchSaga';
function* projectSaga() {
  const fetchProjectSaga = createFetchSaga(fetchProjectActions, fetchProject);
  yield* fetchProjectSaga();
}
export default projectSaga;
